import React from 'react';
import { Link } from 'react-router-dom';

const sizeClasses = {
  sm: 'px-3 py-1.5 text-sm',
  md: 'px-4 py-2 text-sm',
  lg: 'px-6 py-3 text-base',
};

const variantColorClasses = {
  solid: {
    amber: 'bg-amber text-white hover:bg-amber-dark focus:ring-amber',
    navy: 'bg-navy text-white hover:bg-navy-medium focus:ring-navy',
  },
  outline: {
    amber: 'border-2 border-amber text-amber bg-transparent hover:bg-amber hover:text-white focus:ring-amber',
    navy: 'border-2 border-navy text-navy bg-transparent hover:bg-navy hover:text-white focus:ring-navy',
  },
  ghost: {
    amber: 'text-amber bg-transparent hover:bg-amber-tint focus:ring-amber',
    navy: 'text-navy bg-transparent hover:bg-bg-ice focus:ring-navy',
  },
};

function Button({
  children,
  variant = 'solid',
  color = 'amber',
  size = 'md',
  to,
  href,
  onClick,
  type = 'button',
  className = '',
  disabled = false,
}) {
  const base =
    'inline-flex items-center justify-center font-sans font-medium rounded transition-colors focus:outline-none focus:ring-2 focus:ring-offset-1 disabled:opacity-50 disabled:cursor-not-allowed';
  const classes = [
    base,
    sizeClasses[size] || sizeClasses.md,
    variantColorClasses[variant]?.[color] || variantColorClasses.solid.amber,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  if (to) {
    return (
      <Link to={to} className={classes}>
        {children}
      </Link>
    );
  }

  if (href) {
    return (
      <a href={href} className={classes} target="_blank" rel="noopener noreferrer">
        {children}
      </a>
    );
  }

  return (
    <button type={type} onClick={onClick} className={classes} disabled={disabled}>
      {children}
    </button>
  );
}

export default Button;
